import { api } from "./api";

// Online membership store (MongoDB via backend API).
export const listMembers = () => api.get("/members").then((r) => r.data);

export const addMember = (data) =>
  api
    .post("/members", {
      name: data.name,
      dob: data.dob,
      email: data.email,
      phone: data.phone,
      parent_phone: data.parentPhone || "",
    })
    .then((r) => r.data);

export const deleteMember = (id) => api.delete(`/members/${id}`);

export const updateMember = (id, data) =>
  api.patch(`/members/${id}`, data).then((r) => r.data);

export const lookupMember = (name, dob) =>
  api.post("/members/lookup", { name, dob }).then((r) => r.data);

export const markAttendance = (memberId, type) =>
  api.post("/attendance", { member_id: memberId, type, source: "selfscreen" }).then((r) => r.data);

export const listAttendance = () => api.get("/attendance").then((r) => r.data);

export const importMembers = (payload) =>
  api.post("/members/import", payload).then((r) => r.data);

export const registerMember = (data) =>
  api
    .post("/members/register", {
      name: data.name, dob: data.dob, email: data.email, phone: data.phone,
      parent_phone: data.parentPhone || "",
    })
    .then((r) => r.data);

export const registerEvent = (slug, who, tickets = 1, payment = "door") =>
  api.post("/events/register", { slug, ...(typeof who === "string" ? { member_id: who } : who), tickets, payment, origin_url: window.location.origin }).then((r) => r.data);

export const paymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const listEventRegistrations = (slug) =>
  api.get(`/events/${slug}/registrations`).then((r) => r.data);

export const eventInfo = (slug) => api.get(`/events/${slug}`).then((r) => r.data);
